import { InputValidator, InputValue } from './model';

export const validateInput = async (
  value: string,
  validator?: InputValidator,
): Promise<InputValue> => {
  return {
    value,
    isValid: validator ? await Promise.resolve(validator(value)) : true,
  };
};
